import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import { PaletizacionesApi } from "../api/PaletizacionesApi";
import LoadMask from "../../../../../../../Utils/LoadMask/LoadMask";
import { PaletizacionesTable } from "./PaletizacionesTable";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { MetricasPaletizacion } from "../../../../components/MetricasPaletizacion/MetricasPaletizacion";
import { ProduccionV2Api } from "../../../../../api/ProduccionV2Api";
import { DecisionSwal } from "../../../../../../../Utils/Utils/DecisionSwal";
import { ESTADOS_PALETIZACION } from "../../../../../../../../../utility/constants";
import {
    MostrarMensajePaletizacionesPendientes,
    MostrarMensajePaletizacionesSinEnviar,
    MostrarMensajePaletizacionPendiente,
} from "../utils/MensajesSwal";
import { BadgeReabrirPaletizacion } from "../../../../components/BadgeReabrirPaletizacion/BadgeReabrirPaletizacion";
const refreshIcon = require("assets/img/icons/refresh.png");

export const Listado = ({ regresar, navigateToPaletizacionForm }) => {
    const [paletizaciones, setPaletizaciones] = useState([]);
    const [metricasPaletizacion, setMetricasPaletizacion] = useState({});
    const [paletizacionCerrada, setPaletizacionCerrada] = useState(false);

    const {
        getPaletizaciones,
        crearPaletizacion,
        deletePaletizacion,
        cerrarPaletizacion,

        cargando,
    } = PaletizacionesApi();

    const {
        getMetricasPaletizacionTurno,
        getTurnoActual,

        cargandoProdV2,
    } = ProduccionV2Api();

    const CrearPaletizacion = async () => {
        // si hay paletización sin enviar, mostrar advertencia en el mensaje
        if (hayPaletizacionSinEnviar) {
            MostrarMensajePaletizacionesSinEnviar();
            return;
        }

        try {
            const paletizacion = await crearPaletizacion();

            if (paletizacion && paletizacion.id) {
                NotificationManager.success(
                    "Paletización creada con éxito",
                    "Éxito",
                    3000,
                );

                navigateToPaletizacionForm(paletizacion.id);
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear la paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            FetchData();
        }
    };

    const GetPaletizaciones = async () => {
        try {
            const response = await getPaletizaciones();
            setPaletizaciones(response || []);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las paletizaciones",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setPaletizaciones([]);
        }
    };

    const GetMetricasPaletizacion = async () => {
        try {
            const response = await getMetricasPaletizacionTurno();
            setMetricasPaletizacion(response || {});
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las métricas de paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setMetricasPaletizacion({});
        }
    };

    const GetTurnoActual = async () => {
        try {
            const response = await getTurnoActual();
            setPaletizacionCerrada(response.paletizacion_cerrada);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el turno actual",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const FetchData = () => {
        GetPaletizaciones();
        GetMetricasPaletizacion();
        GetTurnoActual();
    };

    useEffect(() => {
        FetchData();
    }, []);

    const EliminarPaletizacion = async (id) => {
        try {
            await deletePaletizacion(id);
            NotificationManager.success(
                "Paletización eliminada correctamente",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        } finally {
            FetchData();
        }
    };

    const CerrarPaletizacion = async () => {
        try {
            await cerrarPaletizacion();
            NotificationManager.success(
                "Paletización cerrada correctamente",
                "Éxito",
                3000,
            );
            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cerrar paletización",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            FetchData();
        }
    };

    const MostrarMensajeCierrePaletización = () => {
        // si hay paletización sin enviar, mostrar advertencia en el mensaje
        if (hayPaletizacionSinEnviar) {
            MostrarMensajePaletizacionesSinEnviar();
            return;
        }

        // si hay paletizacion pendiente, mostrar mensaje de advertencia
        if (hayPaletizacionPendiente) {
            MostrarMensajePaletizacionesPendientes();
            return;
        }

        // si todavía hay producción sin paletizar, mostrar advertencia en el mensaje
        if (metricasPaletizacion.sin_paletizar) {
            const sinPaletizar = metricasPaletizacion.sin_paletizar;
            const turnoActual = sinPaletizar.turno_actual;
            const turnoAnterior = sinPaletizar.turno_anterior;

            if (turnoActual.pacas > 0 || turnoAnterior.pacas > 0) {
                MostrarMensajePaletizacionPendiente(
                    turnoActual.peso,
                    turnoAnterior.peso,
                );
                return;
            }
        }

        let mensaje = "¿Está seguro de cerrar la paletización?";
        mensaje += `\n\nYa no podrá reportar producción ni enviar más pallets a bodega luego de cerrar la paletización.`;

        DecisionSwal(
            mensaje,
            "Sí",
            "No",
            () => CerrarPaletizacion(),
        );
    };

    const hayPaletizacionSinEnviar = paletizaciones.some(
        (p) => p.estado === ESTADOS_PALETIZACION.SIN_ENVIAR,
    );

    const hayPaletizacionPendiente = paletizaciones.some(
        (p) => p.estado === ESTADOS_PALETIZACION.PENDIENTE,
    );

    return (
        <div className="paletizaciones__tab-wrapper">
            <LoadMask loading={cargando || cargandoProdV2} blur>
                <CardEmpty noShadow>
                    <MetricasPaletizacion
                        metricasPaletizacion={metricasPaletizacion}
                        mode="sin_paletizar"
                    />

                    <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                        <div className="d-flex gap-1rem flex-1">
                            <h5 className="mb-0">Traslados a bodega</h5>
                            <img
                                src={refreshIcon}
                                alt="Refrescar datos"
                                title="Refrescar datos"
                                className="action_img"
                                onClick={() => {
                                    FetchData();
                                }}
                            />
                        </div>

                        {!paletizacionCerrada && (
                            <button
                                className="btn btn-primary"
                                onClick={CrearPaletizacion}
                            >
                                Crear Paletización
                            </button>
                        )}
                    </div>

                    <PaletizacionesTable
                        paletizaciones={paletizaciones}
                        EliminarPaletizacion={EliminarPaletizacion}
                        paletizacionCerrada={paletizacionCerrada}
                    />

                    <MetricasPaletizacion
                        metricasPaletizacion={metricasPaletizacion}
                        mode="paletizado"
                    />

                    <div className="d-flex justify-content-center mt-3 mb-3">
                        <div className="d-flex gap-1rem flex-1"></div>
                        <div className="d-flex gap-1rem flex-1 justify-content-center">
                            <button
                                className="btn btn-outline-dark"
                                onClick={regresar}
                            >
                                Regresar
                            </button>
                        </div>
                        <div className="d-flex gap-1rem flex-1 justify-content-end">
                            {!paletizacionCerrada ? (
                                <button
                                    className="btn btn-secondary"
                                    onClick={MostrarMensajeCierrePaletización}
                                >
                                    Cerrar paletización
                                </button>
                            ) : (
                                <BadgeReabrirPaletizacion
                                    onReabierta={FetchData}
                                />
                            )}
                        </div>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
